<template>
  <div>
    <div style="margin-bottom:20px;margin-top: 36px;">
      <b-card>
        <div style="display: flex;">
          <b-form-input size="lg" type="search" class="mr-sm-2" placeholder="请输入" v-model="keyWord"></b-form-input>
          <b-button size="md" class="my-2 my-sm-0" type=""
            style="background-color: #FFBA01;border-color: #FFBA01;width: 100px;" @click="goSearch">搜索</b-button>
        </div>
      </b-card>
    </div>
    <div style="margin-bottom: 30px;">
      <b-card>
        <h5 class="noticeItem" v-for="(item,index) in noticeList" @click="noticeDetail(item)">
          <span style="margin-right: 10px;">{{ item.title }}</span><b-badge variant="danger">公告</b-badge>
        </h5>
      </b-card>
    </div>
    <div class="userBox">
      <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;"
        v-if="!userInfo.id">
        <b-card>
          <b-row class="text-center">
            <b-col cols="12">
              <p style="font-size: 20px;">登陆后，戏曲有约内容更有趣</p>
              <b-form-input v-model="phone" placeholder="请输入手机号" style="margin-bottom: 10px;"></b-form-input>
              <b-form-input v-model="password" placeholder="请输入密码" type="password"
                style="margin-bottom: 10px;"></b-form-input>
              <b-button variant="warning" style="color: #fff;" @click="doLogin">登录/注册</b-button>
            </b-col> </b-row> </b-card>
      </div>
      <div v-else>
        <b-card>
          <b-row class="text-center">
            <b-col cols="12" style="display: flex;justify-content: flex-start;align-items: center;">
              <b-avatar :src="userInfo.avatar" size="100" variant="light"></b-avatar>
              <div
                style="display: flex;justify-content: flex-start;flex-direction: column;align-items: flex-start;margin-left: 10px;">
                <h5 class="card-title">{{ userInfo.name }}</h5>
                <div style="display: flex;justify-content: flex-start;">
                  <p class="card-text" style="margin-right: 10px;"> 积分：{{ userInfo.points }}</p>
                  <p class="card-text">{{ userInfo.level_name }} </p>
                </div>
              </div>
            </b-col>
            <b-col cols="12">
            </b-col>
            <!-- <b-col cols="12">
              <p class="card-text">{{ userInfo.phone }}</p>
            </b-col> -->
            <b-col cols="12">
            </b-col>
            <b-col cols="12">
            </b-col>
            <b-col cols="12">
              <!-- <b-button variant="warning" style="color: #fff;margin-top: 16px;" @click="goRIch(1)">戏迷商城</b-button>
              <b-button variant="warning" style="color: #fff;margin-top: 16px;" @click="goRIch(2)">戏迷福利微信群</b-button>
              <b-button variant="warning" style="color: #fff;margin-top: 16px;"
                @click="goRIch(3)">关于戏迷有约及免责声明</b-button> -->
              <b-button variant="warning" style="color: #fff;margin-top: 16px;" @click="myCollect">我的收藏</b-button>
              <b-button variant="warning" style="color: #fff;margin-top: 16px;" @click="loginOut">退出登录</b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
    <el-dialog :title="richTit" :visible.sync="dialogVisible" width="50%">
      <div v-html="richtext"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    register,
    login,
    getNotice,
  } from '../../api/api.js'
  import {
    mapActions,
    mapGetters
  } from 'vuex'
  import {
    commonData
  } from '../../api/api.js'
  export default {
    computed: {
      ...mapGetters(['userInfo'])
    },
    data() {
      return {
        user: {
          avatar: "https://via.placeholder.com/150",
          nickname: "用户昵称",
        },
        phone: "",
        password: '',
        dialogVisible: false,
        richtext: '',
        richTit: '',
        keyWord: '',
        noticeList: [],
      }
    },
    created() {
      this.getNoticeIndex()
    },
    methods: {
      noticeDetail(item) {
        this.$router.push({
          name: 'noticeDetail',
          params: {
            item,
          }
        })
      },
      getNoticeIndex() {
        //获取公告
        getNotice({
          page: 1
        }).then(res => {
          console.log(res);
          this.noticeList = res.data.data
        })
      },
      goSearch() {
        if (!this.keyWord) {
          this.$message.error('关键词不能为空')
          return
        }
        console.log(this.keyWord);
        this.$router.push({
          name: 'searchPage',
          params: {
            key: this.keyWord
          }
        })
      },
      goRIch(e) {
        commonData({}).then(res => {
          console.log(res);
          switch (e) {
            case 1:
              window.open(res.data.data.shop_url)
              break;
            case 2:
              this.richtext = res.data.data.WechatGroup
              this.richTit = '戏迷福利微信群'
              this.dialogVisible = true
              break;
            case 3:
              this.richtext = res.data.data.statement
              this.richTit = '关于戏迷有约及免责声明'
              this.dialogVisible = true
              break;
          }
        })
      },
      doLogin() {
        if (this.password == '' || this.phone == '') {
          this.$message.error('请完善账号密码')
          return
        }
        register({
          nickname: '戏迷' + this.phone.slice(-4),
          phone: this.phone,
          password: this.password
        }).then(res => {
          console.log(res);
          this.$store.dispatch('getUserInfo2', res.data.data.id)
        })
      },
      myCollect() {
        this.$router.push({
          name: 'collectPage',
          params: {}
        })
      },
      loginOut() {
        this.$store.dispatch('logOut', 0)
      }
    }
  }
</script>

<style>
  .userBox {
    width: 100%;
  }

  .text-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/userBox/userBox.vue